<template>
  <div>
    <div class="head">
      <div class="head-play">
        <div class="logoBox">
          <img src="../../../static/indexImg/logo1.png" class="logo" @click='JumpIndex(islink)'>
          <!--@click="$router.push({name:'majorfunction'})"-->
     <!--     <div class="returnBtnBox">
            <Button type="primary" @click="$router.push({name:'majorfunction'})">{{$t('i.login.returnHome')}}</Button>
            <Button type="primary" style="margin-left: 10px;" @click="returnPrevious">{{$t('i.login.returnPrevious')}}</Button>
          </div>-->
        </div>
        <div class="line"></div>
        <div class="internalText1Box">
          <p class="internalText1" @click="JumpIndex(islink)">{{$t("i.system.name")}}</p>
        </div>
        <div class="internalText2Box">
          <p class="iearningText2">E-Learning system</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
  export default {
    name: "logoHead",
    data() {
      return {
        userInfo: localStorage.userInfo,
      }
    },
    computed: {
      ...mapState({
        noReadNum: (state) => state.noReadNum,
      }),
    },
    methods:{
      toPersonNews() {
        this.$router.push({name:'personNews',query : {}})
      },
      returnPrevious(){
        this.$router.go(-1);
      },
      JumpIndex(islink){
        if(islink === false){
          console.log('')
        }else{
          this.$router.push({name:'majorfunction'});
        }
      }
    },
    props:['islink']
  }
</script>

<style scoped>
  span.person-center {
      float: right;
      font-size: 42px;
      position: relative;
      cursor: pointer;
  }
  .no-read-num{
    font-size: 20px;
    position: absolute;
    right: 1px;
    top: 1px;
    color: red;
    font-weight: 700;
  }
  .head{
    width: 100%;
    height: 230px;
    overflow: hidden;
  }
  .head-play{
    width: 1150px;
    height: 230px;
    margin: 0 auto;
    overflow: hidden;
  }
  .logoBox{
    width: 1150px;
    height: 46px;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .returnBtnBox{
    float: right;
    margin-top: 10px;
  }
  .logo{
    width: 30%;
    height: auto;
    cursor: pointer;
    margin-left: 5px;
  }
  .line{
    width: 1150px;
    height: 2px;
    box-shadow: 0 2px 2px #ccc;
  }
  .internalText1Box{
    width: 1150px;
    height: 75px;
    margin-top: 5px;
  }
  .internalText1{
    display:block;
    font-family: "微软雅黑";
    font-size: 65px;
    color: #e50020;
    text-align: center;
    cursor:pointer;
  }
  .internalText2Box{
    width: 1150px;
    height: 50px;
    text-align: center;
  }
  .iearningText2{
    font-size: 36px;
    font-family: "微软雅黑";
    color: #e50020;
  }

</style>



// WEBPACK FOOTER //
// src/common/components/loginLogoHead.vue